import { useAppointmentStore } from "../store/useAppointmentStore";
import { useCallback } from "react";
import { useChatStore } from "../store/useChatStore";
export function useAppointmentSummary() {
  
  const activeChannel = useChatStore((state) => state.activeChannel);
  const userDetails = useChatStore((state) => state.userDetails);
  const {
    setAppointmentSummaryDetails,
    setIsAppointmentSummaryPopupOpen,
  } = useAppointmentStore();

  const openAppointmentSummary = useCallback((message, isMyMessage, isSender, event) => {
    if (event) {
      event.preventDefault?.();
      event.stopPropagation?.();
    }

    // Null safety checks for message and appointment data
    if (!message) {
      console.error("Appointment summary failed: Missing message data.");
      return;
    }

    const appointmentmsg = message?.appointment || {};
    const appointmentInfo = appointmentmsg || {};

    // Validate required appointment data
    if (!appointmentInfo || !message.id) {
      console.error("Appointment summary failed: Missing required appointment data.", {
        messageId: message?.id,
        appointmentInfo,
      });
      return;
    }

    // Set appointment summary details with null safety
    setAppointmentSummaryDetails({
      messageId: message.id,
      date: appointmentInfo.date ? appointmentInfo.date : null,
      dateString: appointmentInfo.date || null,
      startTime: appointmentInfo.startTime || null,
      endTime: appointmentInfo.endTime || null,
      location: appointmentInfo.location || null,
      title: appointmentInfo.title || null,
      note: appointmentInfo.note || null,
      targetId: userDetails?.secondary?.id || null,
      name: appointmentInfo.name || null,
      totalMinutes: appointmentInfo.totalMinutes || 0,
      status: appointmentmsg.status || 0,
      channelId: activeChannel?.cid || null,
      isMyMessage: !!isMyMessage,
      isSender: !!isSender,
    });

    // Open the modal
    setIsAppointmentSummaryPopupOpen(true);
  }, [activeChannel, userDetails, setAppointmentSummaryDetails, setIsAppointmentSummaryPopupOpen]);

  const closeAppointmentSummary = useCallback(() => {
    setIsAppointmentSummaryPopupOpen(false);
  }, [setIsAppointmentSummaryPopupOpen]);

  return { openAppointmentSummary, closeAppointmentSummary };
}